export default __webpack_public_path__ + "static/dom-jednorodzinny-4d8476135fae0ef37ada1da1c8811246.png";